// src/Utils/getCyberLogIcon.js
import React from 'react';
import { FaGraduationCap } from 'react-icons/fa';
import { MdOutlineLan } from 'react-icons/md';

import { ReactComponent as ConformitaGeneraleIcon } from '../Assets/CyberLogIcons/Conformità generale.svg';
import { ReactComponent as AmbitiConformitaIcon }     from '../Assets/CyberLogIcons/Ambiti di conformità.svg';
import { ReactComponent as ConsapevolezzaIcon }      from '../Assets/CyberLogIcons/Consapevolezza.svg';
import { ReactComponent as FileAngelIcon }           from '../Assets/CyberLogIcons/File Angel.svg';
import { ReactComponent as BrowsingAngelIcon }       from '../Assets/CyberLogIcons/Browsing Angel.svg';
import { ReactComponent as CyberSurveillanceIcon }   from '../Assets/CyberLogIcons/Cyber Surveillance.svg';
import { ReactComponent as ReportisticaIcon }        from '../Assets/CyberLogIcons/Reportistica.svg';
import { ReactComponent as TaskManagerIcon }         from '../Assets/CyberLogIcons/Task Manager.svg';

// Map by stable sidebar key (language-independent)
const iconByKey = {
  'generalCompliance': ConformitaGeneraleIcon,
  'complianceAreas': AmbitiConformitaIcon,
  'awareness': ConsapevolezzaIcon,
  'awarenessTraining': FaGraduationCap,
  'networkingSurveillance': MdOutlineLan,
  'fileAngel': FileAngelIcon,
  'browsingAngel': BrowsingAngelIcon,
  'cyberSurveillance': CyberSurveillanceIcon,
  'reporting': ReportisticaIcon,
  'taskManager': TaskManagerIcon,
};

// Legacy map by Italian label (for backward compatibility with enterprise frontend)
const iconByLabel = {
  'Conformità generale': ConformitaGeneraleIcon,
  'Ambiti di conformità': AmbitiConformitaIcon,
  'Consapevolezza': ConsapevolezzaIcon,
  'File Angel': FileAngelIcon,
  'Browsing Angel': BrowsingAngelIcon,
  'Cyber Surveillance': CyberSurveillanceIcon,
  'Reportistica': ReportisticaIcon,
  'Task Manager': TaskManagerIcon,
};

const getCyberLogIcon = (name, props = {}) => {
  // Check by stable key first
  const ByKey = iconByKey[name];
  if (ByKey) return <ByKey {...props} />;
  // Fallback to legacy label matching
  const ByLabel = iconByLabel[name];
  if (ByLabel) return <ByLabel {...props} />;
  return null;
};

export default getCyberLogIcon;
